import React from 'react';
import {Link} from 'react-router-dom'
import './News.css';

function News() {
  return (
    <div className="main news">
      <div className="news__container">
        <div className="news__items">
          <article className="news__item">
            <div className="news__row">
              <div className="news__colImage">
                <Link to="/katepilla">
                  <img
                    width="390"
                    height="237"
                    src="https://i.ytimg.com/vi/25nAvBYAlxU/maxresdefault.jpg"
                    alt="h.e.r"
                    sizes="(max-width: 390px) 100vw, 390px"
                  />
                </Link>
              </div>
              <div className="news__colContent">
                <header>
                  <time
                    pubdate=""
                    datetime="2021-05-13T11:48:09-05:00"
                    className="date"
                  >
                    May 13 2021
                  </time>

                  <h2 className="news-title">
                    <Link to="/katepilla">
                      BRUCE MELODY LATEST MUSIC IS OUT NOW IS CALLED KATEPILLA
                      
                    </Link>
                  </h2>
                </header>
                <blockquote className="blockquote-unstyled">
                  <p>
                    Bruce Melody bring the heat in their new official video
                    for “Katepilla”! Check out the video below.
                  </p>
                </blockquote>
                <footer>
                  <Link to="/katepilla">
                    Read More
                  </Link>
                  <span className="sep">|</span>
                  <Link to="/katepilla">
                    Share
                  </Link>
                </footer>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  );
}

export default News;
